import { Logger } from '../types';

const LOG_METHODS: ReadonlyArray<keyof Logger> = ['debug', 'error', 'info', 'warn'];

export function withPrefix(logger: Logger, prefix: string): Logger {
  const addPrefix = (message: string) => `${prefix} ${message}`;

  return LOG_METHODS.reduce((acc, method) => {
    acc[method] = (message: string | Error, e?: Error): void => {
      if (typeof message === 'string') {
        logger[method](addPrefix(message), e);
      } else {
        logger[method](message);
      }
    };

    return acc;
  }, {} as Logger);
}
